import React from 'react';
import { Button,Icon,Modal,Radio } from 'antd';
import moment from 'moment';
import styles from './index.less';

class SDKList extends React.Component {

    state = {
        loading:false,
        showMoreList:{},
        selectIndex:0,
        modalText:'',
        list:[]
    }

    toggleMore = (group_id)=>{
        const {showMoreList} = this.state;
        const newList = {...showMoreList};
        if(showMoreList[group_id]){
            newList[group_id] = false;
        }else{
            newList[group_id] = true;
        }
        this.setState({showMoreList:newList});
    }

    onShowDownload = (list,modalText)=>{
        //默认选中第一个
        this.setState({list,selectIndex:0,modalText});
    }

    onDownload = ()=>{
        const item = this.state.list[this.state.selectIndex];
        window.open(item.url);
        this.setState({list:[]});
    }

    onCloseModal = ()=>{
        this.setState({list:[]});
    }

    onChange = (e)=>{

        this.setState({selectIndex:e.target.value});
    }

    render() {
        const {showMoreList,modalText} = this.state;
        const {data} = this.props;
        return (
            <div>
                {data.map(group=>{
                    if(group.list.length === 0) return null;
                    const isShow = showMoreList[group.group_id];
                    return (
                        <div className={styles.group} key={group.group_id}>
                            <h1 className={styles.groupTitle}>{group.groun_name}</h1>
                            <div>
                                {group.list.map((item,index)=>{
                                    if(!isShow && index>0) return;
                                    return (
                                        <div key={index} className={styles.sdkPart}>
                                            <div className={styles.sdkInfo}>
                                                <div className={styles.title}>
                                                    <h2>{item.version}</h2>
                                                    {item.tag !=='' && <span>{item.tag}</span>}
                                                </div>
                                                <div className={styles.time}>{moment(item.release_time,'X').format('YYYY-MM-DD')}</div>
                                                <div className={styles.desc}>Release Notes：{item.desc}</div>
                                            </div>
                                            <div className={styles.downloadPart}>
                                                <Button
                                                    disabled={item.ios_info.length === 0}
                                                    className={styles.button}
                                                    size='large'
                                                    onClick={this.onShowDownload.bind(this,item.ios_info,item['modal_text'])} >iOS download</Button>
                                                <Button
                                                    disabled={item.android_info.length === 0}
                                                    className={styles.button}
                                                    size='large'
                                                    onClick={this.onShowDownload.bind(this,item.android_info,item['modal_text'])}>Android download</Button>
                                            </div>
                                        </div>
                                    );
                                })}
                                {group.list.length>1 && <div className={styles.toggleMore} onClick={this.toggleMore.bind(this,group.group_id)}><Icon type={isShow?'up':'down'} /> <span>{isShow?'put away':'expand'}historic version</span> </div>}
                            </div>
                        </div>
                    );
                })}
                <Modal
                    title="Select version type"
                    visible={this.state.list.length !== 0}
                    okText='download'
                    onOk={this.onDownload}
                    onCancel={this.onCloseModal}
                    width={800}
                >
                    {modalText && <div style={{color:'red',whiteSpace:'pre-line'}}>Important Notice:<br/>{modalText}</div>}
                    <div className={styles.radioBox}>
                        {this.state.list.length !== 1?<Radio.Group onChange={this.onChange} value={this.state.selectIndex}>
                            {this.state.list.map((item,index)=>{
                                return (
                                    <Radio key={index} className={styles.radio} value={index}>
                                        {item.msg}
                                    </Radio>
                                );
                            })}
                        </Radio.Group>: <div>{this.state.list[0].msg}</div> }

                    </div>
                </Modal>
            </div>
        );
    }
}

export default SDKList;



// WEBPACK FOOTER //
// ./src/pages/SDKDownload/SDKList.js